import { common as esCommon } from './es/common';
import { home as esHome } from './es/home';
import { services as esServices } from './es/services';
import { pricing as esPricing } from './es/pricing';
import { faqs as esFaqs } from './es/faqs';
import { contact as esContact } from './es/contact';
import { legal as esLegal } from './es/legal';
import { customSolutions as esCustomSolutions } from './es/customSolutions';
import { demo as esDemo } from './es/demo';

import { common as enCommon } from './en/common';
import { home as enHome } from './en/home';
import { services as enServices } from './en/services';
import { pricing as enPricing } from './en/pricing';
import { faqs as enFaqs } from './en/faqs';
import { contact as enContact } from './en/contact';
import { legal as enLegal } from './en/legal';
import { customSolutions as enCustomSolutions } from './en/customSolutions';
import { demo as enDemo } from './en/demo';

export const resources = {
  es: {
    common: esCommon,
    home: esHome,
    services: esServices,
    pricing: esPricing,
    faqs: esFaqs,
    contact: esContact,
    legal: esLegal,
    customSolutions: esCustomSolutions,
    demo: esDemo
  },
  en: {
    common: enCommon,
    home: enHome,
    services: enServices,
    pricing: enPricing,
    faqs: enFaqs,
    contact: enContact,
    legal: enLegal,
    customSolutions: enCustomSolutions,
    demo: enDemo
  }
};
